
















































import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';
import {required, minLength} from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import AuthorizationService from '@/services/api/authorization.service';

import UserProfileIcon from '@/assets/icon/user-profile.svg';

const { mapFields } = createHelpers({
  getterType: 'getLoginFormField',
  mutationType: 'updateLoginFormField',
});

const validations = {
  login: {
    required
  },
  password: {
    required,
    minLength: minLength(8)
  }
};

@Component({
  validations,
  computed: {...mapFields([
      'login',
      'password',
      'submitSuccess'
    ])
  }
})
export default class LoginDBPForm extends Vue {
  private submitSuccess!: boolean;
  private login!: string;
  private password!: string;

  public UserProfileIcon = UserProfileIcon;

  public loginErrorMessageList = {
    required: 'Anmelden ist erforderlich'
  };
  public passwordErrorMessageList = {
    required: 'Passwort wird benötigt',
    minLength: 'Das Passwort muss aus mindestens 8 Zeichen bestehen'
  };

  public openModal(modal: string) {
    this.$emit('openModal', modal);
  }

  public async submit() {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$store.commit('SET_LOADING', {user: true});
      try {
        await AuthorizationService.loginDBP({ email: this.login, password: this.password });
        await this.$store.dispatch('login');
      } catch (error: any) {
        if (error?.response?.status === 401 && error?.response?.data?.errorCode === 'BAD_SESAM_EXISTING_USER_CREDENTIALS') {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Fehler',
            text: 'Wir konnten Sie leider nicht anmelden. Bitte überprüfen Sie Ihren Benutzername und Passwort.'
          });
        }
        if (error?.response?.status === 400 && error?.response?.data?.errorCode === 'SCHOOL_NOT_FOUND') {
          window.dispatchEvent(
            new CustomEvent('closeHeaderModal')
          );
          window.dispatchEvent(
            new CustomEvent('openHeaderModal', { detail: { id: 'school-not-found-login', params: { dish: error?.response?.data?.dish } } })
          );
        }
        if (error?.response?.status === 400 && error?.response?.data?.errorCode === 'USER_IS_ALREADY_LINKED') {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Fehler',
            text: `Zuordnung fehlgeschlagen
             Der SESAM-Benutzer ist bereits einem anderen SCHULE@BW-Benutzer zugeordnet.`
          });
        }
      } finally {
        this.$store.commit('SET_LOADING', {user: false});
      }
    }
  }

  public async goToRegistration() {
    this.$emit('openModal', 'register-dbp');
  }

  @Watch('submitSuccess')
  public onSubmitSuccess(success: boolean) {
    if (success) this.$emit('closeModal');
  } 
}
